<template>
  <div class="rules-container">
    <Modal
      title
      v-model="showDeliverInfo_new"
      @on-cancel="close"
      width="800"
      class-name="vertical-center-modal rules-modal"
    >
      <div :class="['header','signle']">
        物流信息
        <Icon @click="close" type="md-close" />
      </div>
      <div class="package-info">
        <!-- <div class="package-list">
          <div
            @click="changePackage(index)"
            :class="['package',deliveryIndex== index ? 'active':'']"
            v-for="(item,index) in wuliulist"
            :key="index"
            v-if="wuliulist.length>1"
          >
            包裹
            <span>{{index+1}}</span>
          </div>
        </div> -->
        <div class="content">
          <div class="content-info">
            <div class="company">
              <div class="item">
                <div>物流公司：</div>
                <div>{{orderInfo_new.exchangeExpressCompany}}</div>
              </div>
              <div class="item">
                <div>物流单号：</div>
                <div>
                  {{orderInfo_new.exchangeExpressNo}}
                  <span class="copy" @click="copy()">复制</span>
                </div>
              </div>
            </div>
            <div>
              <div v-if="currentWuliuInfo.length>0">
                <div v-for="(item,index) in currentWuliuInfo" :key="index">
                  <div style="margin-bottom:5px">{{item.datetime}}</div>
                  <div>{{item.remark}}</div>
                </div>
              </div>
              <div v-else>暂未查到物流信息</div>
              <!-- 我是包裹
              <span>{{deliveryIndex}}</span>
              区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜
              区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员
              区速递易【自提柜】代收，请及时取件。有问题请联系派件员
              区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员-->
            </div>
          </div>
        </div>
      </div>
      <div class="good-list">
        <div class="cart-item" v-for="(item,index) in orderInfo_new.orderSkuItemExchangeList" :key="index">
          <div class="cart-left">
            <div class="cart-img">
              <img :src="item.productImage" />
            </div>

            <div class="cart-info">
              <div class="cart-info-detail">
                <div class="good-name">
                  <span>{{item.productName}}</span>
                </div>
                <div class="good-size">
                  尺码.
                  <span
                    class="value"
                    v-for="(v, i) in item.specType"
                    :key="i"
                  >{{v}}{{i!=item.specType.length-1?'；':''}}</span>
                </div>
                <div class="good-color">
                  颜色.
                  <span class="value">{{item.colorText}}</span>
                </div>
                <div class="good-num">
                  数量.
                  <span class="value">{{item.productQuantity}}</span>
                </div>
              </div>

              <div class="cart-price">
                <template v-if="item.productDiscountPrice!='0'&&item.productDiscountPrice!=undefined">
                  <div
                    class="originprice"
                    style="margin-bottom:1.5rem"
                  >¥{{$utils.toThousands(item.productPrice) }}</div>
                  <div class="currprice">¥{{$utils.toThousands(item.productDiscountPrice)}}</div>
                </template>

                <template v-else>
                  <div class="currprice">¥{{$utils.toThousands(item.productPrice)}}</div>
                </template>
                <!-- <div class="tips value">已退款</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "DeliveryRules",
  data() {
    return {
      code: "",
      API: this.$store.state.API,
      deliveryIndex: 0,
      showDeliverInfo_new:false,
      currentSkuInfo: [],
      currentWuliuInfo: []
    };
  },
  props: {
    orderInfo: {
      type: Object
    },
    showDeliverInfo: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    orderInfo: {
      immediate: true,
      handler(curVal, oldVal) {
        
        this.orderInfo_new = curVal;
        this.getWuliu()
        
      },
      deep: true //true 深度监听
    },
    showDeliverInfo:{
      handler(curVal, oldVal){
        this.showDeliverInfo_new=curVal
      }
    }
    
  },
  components: {},
  mounted() {
    // this.$nextTick(() => {
    //   this.getWuliu(this.orderInfo_new.exchangeExpressNo);
     
    // });
  },
  methods: {
    copy() {
      var copyTest = this.orderInfo_new.exchangeExpressNo;
      var inputTest = document.createElement("input");
      inputTest.value = copyTest;
      document.body.appendChild(inputTest);
      inputTest.select();
      document.execCommand("Copy");
      inputTest.className = "oInput";
      inputTest.style.display = "none";
      this.$Message.success("复制成功");
    },
    getWuliu() {
      let url = this.API.order.queryLogistics;
      let params = {
        merchantId: this.$store.state.storeId,
        orderId:this.orderInfo_new.orderId,
        shipmentNo:this.orderInfo_new.exchangeExpressNo,
        orderSkuItemRefundId:this.orderInfo_new.orderSkuItemRefundId
      };
      // this.currentSkuInfo = e;
      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            // this.currentSkuInfo = e;
            // console.log(this.currentSkuInfo, "currentSkuInfo");
            this.currentWuliuInfo = res.data.returnData.details || [];
          } else {
            this.currentWuliuInfo = [];
          }
        })
        .catch(err => {
          console.log(err,'失败了吗')
        });
    },
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
    close() {
      this.$emit("closeDelivery");
    }
  }
};
</script>
<style lang="less" scoped>
.part-container {
  padding-top: 3rem;
}

/deep/.rules-modal .ivu-modal-content {
  min-height: 40rem;
  padding: 2rem 2rem;
  margin: auto;
  display: flex;
  justify-content: space-around;
  color: #5c5d5f;
  background-color: #fff;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  .header {
    &.signle {
      margin-bottom: 2rem;
    }
    i {
      float: right;
      font-size: 1.6rem;
      color: #000000;
      margin-top: -0.4rem;
      margin-right: -0.4rem;
      cursor: pointer;
      font-weight: 500;
      // margin-top: -1px;
    }
    text-align: left;
  }
  .package-info {
    margin-bottom: 2rem;
    .package-list {
      display: flex;
      flex-direction: row;
      .package {
        cursor: pointer;
        padding: 2rem 4rem 2rem 0;
        color: #959595;
        &.active {
          color: #5c5d5f;
        }
        span {
          padding: 0 0.3rem;
        }
      }
    }

    .content {
      border: 0.1rem solid #eaeaea;
      padding: 2rem;
      line-height: 1.7rem;
      .content-info {
        max-height: 32rem;
        overflow: auto;
        text-align: left;

        .company {
          padding-bottom: 2rem;
        }
        .company .item {
          display: flex;
          .copy {
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }
  }
  .good-list {
    border: 0.1rem solid #eaeaea;
    padding-top: 2rem;
    height:auto;
    overflow: auto;
    .cart-item {
      // border: 0.1rem solid #eaeaea;
      // border-bottom: none;
    }
  }
}
/deep/.rules-modal .ivu-modal-body {
  padding: 0;
  line-height: 1.2;
  font-size: 1.2rem;
}

/deep/.ivu-modal {
  margin: 10px 0;
  margin-top:100px;
}
@media screen and (max-width: 1440px) {
  .good-list {
    height: auto !important;
  }
}
@media screen and (max-width: 1024px) {
  /deep/.rules-modal .ivu-modal-content {
    width: calc(100% - 4rem);
    min-height: 15rem;
  }
  .good-list {
    height: 35rem !important;
  }
}
@media screen and (max-width: 768px) {
  /deep/ .rules-modal .ivu-modal-content {
    width: 100%;
    padding: 2rem;
  }
  .good-list .cart-item .cart-left .cart-info .cart-price .price1 {
    padding-right: 0;
  }

  /deep/.rules-modal .ivu-modal-content .package-info .content .content-info {
    max-height: 20rem;
  }
}
 .good-list .cart-item .cart-left .cart-info{
    .good-name{
      justify-content:start
    }
    .originprice{
      margin-right:1.5rem
    }
    .originprice,.currprice{
      display:inline-block;
    }
   }
</style>


// WEBPACK FOOTER //
// src/components/common/DeliveryExchange.vue